import "bootstrap/dist/css/bootstrap.min.css";
import AppRoutes from "./routes";

function App() {
  
  return (
    <AppRoutes/>
  );
}

export default App;
